// Service configuration for api url
const serviceConfig = {
  auth: {
    version: "v1.0",
    url: null,
  }, // sample service and version
};

export default serviceConfig;
